/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {Entitlement} from '../models/Entitlement';
import type {MintResTokenRequest} from '../models/MintResTokenRequest';
import type {OfficeEmailSlugSettingsResponse} from '../models/OfficeEmailSlugSettingsResponse';
import type {OpenFileStatusesResponse} from '../models/OpenFileStatusesResponse';
import type {SignedResToken} from '../models/SignedResToken';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class InternalEntitlementsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Mints a res token on behalf of a caller with no DB/signing-key access of its own (Chat,
   * OrderEntry, QC, Marketplace, Webhooks — see ). Deliberately outside this
   * controller's [Authorize] bearer gate — the caller doesn't have a res token yet — and guarded
   * instead by , a narrow HMAC check scoped to just this action.
   * The attribute implies [AllowAnonymous], so none is declared here.
   * The body is caller-supplied, so two things are enforced server-side to bound what a leaked
   * ResToken:MintSecret can mint. The token must be scoped to this deployment's own
   * — every legitimate caller (AuthController, the job minter,
   * the system handler) already sets AllowedCustomer to its own tenant, which is this
   * deployment's tenant — so this endpoint cannot mint a token for another tenant. And the purpose
   * must be one a service legitimately mints here (); Admin-only
   * purposes are signed locally and never come through this endpoint.
   * @returns SignedResToken OK
   * @throws ApiError
   */
  public internalEntitlementsMintToken({
    requestBody,
  }: {
    requestBody: MintResTokenRequest;
  }): CancelablePromise<SignedResToken> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/entitlements/internal/token',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * Evaluates a company feature flag for the calling service's organization. Returns the same
   * shape as the user-facing endpoint so consumers share one contract.
   * @returns Entitlement OK
   * @throws ApiError
   */
  public internalEntitlementsGetCompanyFeature({
    featureKey,
  }: {
    /**
     * The feature key to check (e.g., "EmailNewOrders").
     */
    featureKey: string;
  }): CancelablePromise<Entitlement> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/entitlements/internal/feature/{featureKey}',
      path: {
        featureKey: featureKey,
      },
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Gets the Resware file status ids the calling service's organization counts as "open", used when
   * narrowing several candidate orders down to one while matching an inbound email.
   * Returns an empty list both when the customer has made no selection and when the organization
   * resolves to no customer. The caller treats empty as "unconfigured" and falls back to its own
   * default, so an unprovisioned org behaves the same as an unconfigured one rather than failing
   * the email.
   * @returns OpenFileStatusesResponse OK
   * @throws ApiError
   */
  public internalEntitlementsGetOpenFileStatuses(): CancelablePromise<OpenFileStatusesResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/entitlements/internal/open-file-statuses',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Gets the calling service's organization's inbound-address slug to office mappings, used to route
   * an incoming email to the office that owns it (PBI #104608).
   * Read through this route rather than the admin surface because inbound email arrives with no
   * interactive user, so the caller carries no WorkOS role for the admin endpoints to gate on.
   * Returns an empty list both when the customer has configured nothing and when the organization
   * resolves to no customer; either way the email is left unassigned for manual triage rather than
   * failed.
   * @returns OfficeEmailSlugSettingsResponse OK
   * @throws ApiError
   */
  public internalEntitlementsGetOfficeEmailSlugs(): CancelablePromise<OfficeEmailSlugSettingsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/entitlements/internal/office-email-slugs',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
}
